export default {
    backendUrl: `${process.env.VUE_APP_BACKEND}`,
    frontendUrl: `${process.env.VUE_APP_FRONTEND}`,
}